import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=ff9b955a&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"
import style0 from "./LoginComponent.vue?vue&type=style&index=0&id=ff9b955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b955a",
  null
  
)

export default component.exports